import axios from 'axios';
import { API_URL } from '../config';
export const getBotMonitor = (page = 1) =>
  axios
    .get(`${API_URL}/bot-monitor`, { params: { page }, withCredentials: true })
    .then((r) => r.data);
export const setBotMonitorMail = (notificationsEnabled) =>
  axios
    .patch(
      `${API_URL}/bot-monitor/settings`,
      { notificationsEnabled },
      { withCredentials: true },
    )
    .then((r) => r.data);
